import { gaMiddleware } from './analytics/'

export { gaMiddleware }



// WEBPACK FOOTER //
// ./src/shared/middlewares/index.js